module.exports = __webpack_public_path__ + "img/packages/mobile.e4be73.png";